var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ScreenEditor" },
    [
      _c("Toolbar", {
        attrs: {
          editScreen: _vm.editScreen,
          coordinates: _vm.coordinates,
          selectedItemLabel: _vm.selectedItemLabel,
          filenameWithCoordinates: _vm.filenameWithCoordinates
        },
        on: {
          changeSelectedItemLabel: _vm.onChangeSelectedItemLabel,
          removeScreenMetadata: _vm.onRemoveScreenMetadata,
          zoom: _vm.onZoom
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isInitializing,
              expression: "isInitializing"
            }
          ]
        },
        [_vm._v("Loading...")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isInitializing,
              expression: "!isInitializing"
            }
          ],
          staticClass: "ScreenEditor_Container"
        },
        [
          _c("ViewPort", {
            attrs: {
              editScreen: _vm.editScreen,
              coordinates: _vm.coordinates,
              zoomedWidth: _vm.zoomedWidth,
              zoomedHeight: _vm.zoomedHeight,
              viewbox: _vm.viewbox
            },
            on: {
              addHighlight: _vm.onAddHighlight,
              setImage: _vm.onSetImage,
              selectHighlight: _vm.onSelectHighlight,
              setCoordinates: _vm.onSetCoordinates,
              removeHighlight: _vm.onRemoveHighlight
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }